
import { useState } from 'react';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('submitting');

    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d6dvs1iff40lgbk6dkfg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 5000);
      } else {
        setFormStatus('error');
        setTimeout(() => setFormStatus('idle'), 5000);
      }
    } catch {
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 5000);
    }
  };

  const contactInfo = [
    {
      icon: 'ri-map-pin-line',
      title: '办公地址',
      detail: '厦门市海沧区沧林路447号801室',
    },
    {
      icon: 'ri-warehouse-line',
      title: '仓库地址',
      detail: '厦门市海沧区蓝水郡兴港五里',
    },
    {
      icon: 'ri-phone-line',
      title: '联系电话',
      detail: '+86 138 5990 8889',
    },
    {
      icon: 'ri-mail-line',
      title: '电子邮箱',
      detail: 'ck@xmzhjh.com',
    },
  ];

  return (
    <section id="contact" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              <strong>联系</strong>我们
            </h2>
            <p className="text-gray-600 mb-8">
              准备好优化您的物流运营了吗？联系我们的团队，获取量身定制的解决方案。
            </p>
            <div className="space-y-6">
              {contactInfo.map((item) => (
                <div key={item.title} className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">
                      <a href="#contact" className="hover:text-teal-600 transition-colors">{item.title}</a>
                    </h4>
                    <p className="text-gray-600">{item.detail}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-lg p-8">
            <form
              id="contact-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="space-y-6"
            >
              <div>
                <label className="block text-sm font-medium text-gray-900 mb-2">姓名</label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm outline-none"
                  placeholder="请输入您的姓名"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-900 mb-2">电子邮箱</label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm outline-none"
                  placeholder="example@email.com"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-900 mb-2">联系电话</label>
                <input
                  type="tel"
                  name="phone"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm outline-none"
                  placeholder="+86 138-0000-0000"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-900 mb-2">留言内容</label>
                <textarea
                  name="message"
                  required
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm resize-none outline-none"
                  placeholder="请描述您的物流需求..."
                ></textarea>
              </div>
              {formStatus === 'success' && (
                <div className="bg-green-50 text-green-800 px-4 py-3 rounded-lg text-sm">
                  感谢您的留言！我们已收到您的信息，将尽快与您联系。
                </div>
              )}
              {formStatus === 'error' && (
                <div className="bg-red-50 text-red-800 px-4 py-3 rounded-lg text-sm">
                  发送失败，请稍后重试。
                </div>
              )}
              <button
                type="submit"
                disabled={formStatus === 'submitting'}
                className="w-full bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {formStatus === 'submitting' ? '发送中...' : '发送留言'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
